import React from 'react';

import {
    OrderedPanelList,
    TOrderedPanelListItem,
} from 'app/component/orderedPanelList/OrderedPanelList';
import instruction1_1 from 'app/assets/MsiInstructions/1_1.png';
import instruction1_2 from 'app/assets/MsiInstructions/1_2.png';
import instruction2 from 'app/assets/MsiInstructions/2_1.png';
import instruction3_1 from 'app/assets/MsiInstructions/3_1.png';
import instruction3_2 from 'app/assets/MsiInstructions/3_2.png';
import instruction4 from 'app/assets/MsiInstructions/4_1.png';

export const msiInstructionList: TOrderedPanelListItem[] = [
    {
        title: 'Введите идентификационный (личный) номер',
        subTitle: 'Он указан на 33 странице паспорта или на ID-карте',
        content: (
            <OrderedPanelList.ImageContent
                images={[instruction1_1, instruction1_2]}
                imageDimensions={[
                    [140, 236],
                    [124, 148],
                ]}
            />
        ),
    },
    {
        title: 'Введите одноразовый пароль из СМС. После чего нажмите кнопку «Войти»',
        subTitle: 'Важно! Никому не сообщайте полученный СМС-пароль!',
        content: (
            <OrderedPanelList.ImageContent
                images={instruction2}
                imageDimensions={[187, 110]}
            />
        ),
    },
    {
        title: 'Разрешите использование камеры. Посмотрите в камеру и нажмите кнопку «Войти»',
        subTitle: 'Чтобы вы могли сделать фото и подтвердить, что в аккаунт входите именно вы',
        content: (
            <OrderedPanelList.ImageContent
                images={[instruction3_1, instruction3_2]}
                imageDimensions={[
                    [140, 274],
                    [140, 274],
                ]}
            />
        ),
    },
    {
        title: 'Нажмите кнопку «Разрешить»',
        subTitle: 'Чтобы передать ваши данные из МСИ в Альфа Банк',
        content: (
            <OrderedPanelList.ImageContent
                images={instruction4}
                imageDimensions={[140, 296]}
            />
        ),
    },
];
